<div style="max-height: 650px; overflow-y: scroll">
  <mat-tree #uploadtree [dataSource]="dataSource" [(treeControl)]="treeControl">
    <mat-tree-node
      class="site-tree-node"
      *matTreeNodeDef="let node"
      matTreeNodeToggle
      matTreeNodePadding
      (click)="activeNode = node"
    >
      <div class="row" style="width: 100%">
        <div class="col-md-8">
          <button
            type="button"
            (click)="$event.preventDefault()"
            bciprimarybutton
            disabled
          ></button>
          <mat-label (click)="featureLeafItemSelectionToggle(node)">{{
            node.title
          }}</mat-label>
        </div>
        <div class="col-md-4" style="text-align: right">
          <button
            class="button-primary"
            bciprimarybutton
            (click)="openUploadImageModal(node)"
            *ngIf="node.hasAttachment === true || node.nodeType === 'LOAD'"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="edit icon"
                class="bosch-ic-paperclip"
                style="width: max-content"
              ></mat-icon>
            </span>
          </button>
        </div>
      </div>
    </mat-tree-node>

    <mat-tree-node
      class="site-tree-node"
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding
      (click)="activeNode = node"
    >
      <div class="row" style="width: 100%">
        <div class="col-md-7">
          <button
            type="button"
            (click)="$event.preventDefault()"
            bciprimarybutton
            matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.filename"
          >
            <mat-icon
              *ngIf="treeControl.isExpanded(node)"
              fontIcon="Bosch-Ic-arrow-expand-down"
            ></mat-icon>
            <mat-icon
              *ngIf="!treeControl.isExpanded(node)"
              fontIcon="Bosch-Ic-arrow-expand-right"
            ></mat-icon>
          </button>
          <mat-label>{{ node.title }}</mat-label>
        </div>
        <div class="col-md-5" style="text-align: right">
          <button
            class="button-primary"
            bciprimarybutton
            (click)="openUploadImageModal(node)"
            *ngIf="node.hasAttachment === true || node.nodeType === 'LOAD'"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="edit icon"
                class="bosch-ic-paperclip"
                style="width: max-content"
              ></mat-icon>
            </span>
          </button>
        </div>
      </div>
    </mat-tree-node>
  </mat-tree>
</div>
